(() => {
  if (customElements.get('nebula-mission')) return;

  class NebulaMission extends HTMLElement {
    #observer = null;

    connectedCallback() {
      const stage = this.querySelector('.js-nm-stage');
      if (!stage) return;

      this.#observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;

          // Phase 1: images converge to center
          stage.classList.add('is-animated');

          // Phase 2: blue bg fades in on head after convergence completes (~2s)
          setTimeout(() => {
            stage.classList.add('is-swapped');
          }, 2000);

          this.#observer.disconnect();
          this.#observer = null;
        },
        { threshold: 0.65 }
      );

      this.#observer.observe(stage);
    }

    disconnectedCallback() {
      this.#observer?.disconnect();
    }
  }

  customElements.define('nebula-mission', NebulaMission);
})();
